import React from 'react'
import { connect } from 'react-redux'

export const Report = (props) => {
  return (
    <div>Report</div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Report)